export const mainsLoadSuccess = (mains) => {
    return { type : 'MAINS_LOAD_SUCCESS', payload : { mains } }
}

export const mainsLoadFail = () => {
    return { type: 'MAINS_LOAD_FAIL' }
}

export const loadMains = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const mainsRef = firebase.ref('mains/').orderByChild('order');

        mainsRef.once('value', (snapshot) => {
            let mains = [];
            snapshot.forEach(main => {
                mains.push({
                    id: main.key,
                    ...main.val()
                });
            })
            dispatch(mainsLoadSuccess(mains));
        })
    } 
}

//Introductions
export const introductionsLoadSuccess = (introductions) => {
    return {
        type : 'INTRODUCTIONS_LOAD_SUCCESS',
        payload : {
            introductions
        }
    }
}
export const introductionsLoadFail = () => {
    return {
        type  : 'INTRODUCTIONS_LOAD_FAIL'
    }
}
export const loadIntroductions = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const introductionsRef = firebase.ref('introductions/').orderByChild('order');

        introductionsRef.once('value', (snapshot)=> {
            let introductions = []; 
            snapshot.forEach(intro => {
                introductions .push({
                    id : intro.key,
                    ...intro.val()
                });
            })
            dispatch(introductionsLoadSuccess(introductions));
        })
    }
}

export const casesLoadSuccess = (cases) => {
    return {
        type : 'CASES_LOAD_SUCCESS',
        payload : {
            cases
        }
    }
}
export const casesLoadFail = () => {
    return {
        type : 'CASES_LOAD_FAIL',
    }
}
export const loadCases = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const casesRef = firebase.ref('cases/').orderByChild('order');
        casesRef.once('value', (snapshot)=> {
            let cases = []; 
            snapshot.forEach(c => {
                cases .push({
                    id : c.key,
                    ...c.val()
                });
            })
            dispatch(casesLoadSuccess(cases));
        })
    }
}

export const departmentsLoadSuccess = (name, departments) => {
    return {
        type : 'DEPARTMENTS_LOAD_SUCCESS',
        payload : {
            name,
            departments
        }
    }
}

export const loadDepartment = (subDepartment) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const departmentsRef = firebase.ref(`departments/${subDepartment}`).orderByChild('order');
        departmentsRef.once('value', (snapshot)=> {
            let departments = []; 
            snapshot.forEach(depart => {
                departments.push({
                    id : depart.key,
                    ...depart.val()
                });
            })
            dispatch(departmentsLoadSuccess(subDepartment, departments));
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/Home/actions/homeActions.js